import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_CLASS, CHANGE_CLASS } from './constants';
import {
  loadClassSuccess,
  loadClassError,
  changeClassSuccess,
  changeClassError,
} from './actions';

import requestWrapper from 'utils/requestWrapper';
import _local from 'utils/localStorageUtils';

export function* loadClass(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { id } = action;

    // we get the campaigns linked to the class
    const itemData = yield requestWrapper('GET', `classes/${id}`, '', currentUser.token);

    if (!id && !itemData) {
      yield put(loadClassSuccess(false));
    } else {
      yield put(loadClassSuccess(itemData));
    }
  } catch (error) {
    yield put(loadClassError(error));
  }
}

// Individual exports for testing
export default function* classesDetailSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_CLASS, loadClass);
}
